import type { ReactNode } from "react";
import { Navigate, useParams } from "react-router";
import { useCapabilities } from "@/features/account/useCurrentUser";
import { NotFoundPage } from "@/features/errors/NotFoundPage";
import { knowledgePath } from "./KnowledgeTabs";

/** Knowledge-graph pages exist only when the deployment turns the feature on (`knowledgeGraphEnabled`). */
export function RequireKnowledgeGraph({ children }: Readonly<{ children: ReactNode }>) {
  return useCapabilities().knowledgeGraphEnabled ? children : <NotFoundPage />;
}

/** A space's Knowledge area: the wiki when the feature is on, otherwise straight to its files. */
export function SpaceWikiRoute({ children }: Readonly<{ children: ReactNode }>) {
  const { spaceUuid = "" } = useParams();
  return useCapabilities().knowledgeGraphEnabled ? (
    children
  ) : (
    <Navigate to={knowledgePath(spaceUuid, "files")} replace />
  );
}
